<template>
  <div class="product-page">
    <div class="product-container">
      <div class="product-box white-bg">
        <a @click="$router.go(-1)" class="back-btn">
          <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.25 6.75L4.75 12L10.25 17.25">
            </path>
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.25 12H5"></path>
          </svg>

        </a>
        <div class="product-image">
          <img :src="currentProduct.image" :alt="currentProduct.name">
          <!-- <stars :rate="rated(currentProduct.stars)" :
          totalReviews="currentProduct.totalReviews"/> -->
        </div>
        <div class="product-info">
          <h2 class="product-title">
            <!-- Add 'SABFOIL' prefix if the product is not already branded as 'Moses' -->
            {{ currentProduct.name }}
          </h2>
          <div class="product-price">
            <span class="price" v-if="currentProduct.price"
            :class="{strikethrough: currentProduct.deal_price}">
              CHF {{ currentProduct.price }}<span v-if="!currentProduct.deal_price">.-</span>
            </span>
            <span class='stock-status' v-if="!currentProduct.deal_price">
              <span class='stock-status-color'
              :class="{'in-stock': currentProduct.in_stock}"></span>
              <span class='stock-status-text'>
                {{ currentProduct.in_stock? "IN STOCK" : "OUT OF STOCK" }}
              </span>
            </span>
            <span class='deal-price' v-if="currentProduct.deal_price">
              CHF {{ currentProduct.deal_price }}.-
            </span>
            <span class='deal-sticker' v-if="currentProduct.deal_price">
              {{currentProduct.used ?  "Used" : "Deal"}}
              {{currentProduct.price ? " –" +
              Math.round(100*(currentProduct.price-currentProduct.deal_price)/currentProduct.price)
               + "%" : ""}}
            </span>
          </div>
          <!-- <btn btnColor="btn btn-large btn-sucess" :cartIcon="true"
          @click.native="addProductToCart(currentProduct)">
            Buy Now
          </btn> -->
          <!-- <btn btnColor="btn btn-large btn-info"
              @click.native="openModal()">
            More Info
          </btn> -->
          <ul class="disciplines">
            <li v-for="(discipline, index) in currentProduct.disciplines" :key="index"
             :class="discipline">
              {{ discipline }}
            </li>
          </ul>
          <p class="description pre-formatted" v-html="currentProduct.description"></p>
          <h3>Détails</h3>
          <ul class="detail-items">
            <li v-for="item in currentProduct.details" :key="item.txt">
              {{ item.txt }}
            </li>
          </ul>
          <btn :href="'mailto:info@kitingzone.ch?subject=' + currentProduct.name">
          Contactez-nous
          </btn>
        </div>
        <!-- <modal>{{ currentProduct.details }}</modal> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import btn from './Btn';
import stars from './Stars';
import modal from './Modal';

export default {
  components: {
    btn,
    stars,
    modal,
  },

  computed: {
    currentProduct() {
      // Get the product to display using the uid from the router's path
      const uid = this.$route.params.uid;
      const allTheProducts = Object.values(this.$store.state.all_products)
        .reduce((prod, p) => prod.concat(p), []);
      const matchingProducts = allTheProducts.filter(p => p.uid === uid);
      return matchingProducts[0];
    },
  },

  methods: {
    ...mapActions([
      'addProduct',
      'showOrHiddenModal',
    ]),
    addProductToCart(product) {
      this.addProduct(product);
    },
    rated(rate) {
      return `${rate * 20}%`;
    },
    openModal() {
      this.showOrHiddenModal();
    },
  },

};
</script>

<style scoped>
  .disciplines {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px;
  }

  .product-page {
    /* min-height: 785px; */
    padding-bottom: 4em;
  }

  .product-container {
    width: 100%;
    max-width: 932px;
    margin: 0 auto;
    padding: 3em 0 2em;
  }

  .product-box {
    margin: 0 1em;
    position: relative;
    box-sizing: border-box;
    padding: 3em 3em 3em 1em;
    border-radius: 7px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
  }

  .back-btn {
    background-color: #ddd;
    width: 48px;
    height: 48px;
    position: absolute;
    left: -12px;
    top: -12px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .back-btn:hover {
    background-color: #eee;
  }

  .back-btn svg{
    stroke: #555;
    stroke-width: 2;
    transition: 0.2s;
  }

  .back-btn:hover svg{
    stroke-width: 3;
  }

  .product-image {
    flex: 55%;
    display: flex;
    justify-content: center;
    overflow: hidden;
  }

  .product-image img{
    width: 110%;
  }

  .product-info {
    align-self: flex-start;
    flex: 45%;
  }

  .product-info .description, .product-info .detail-items{
    color: #555;
    line-height: 1.5;
  }

  .product-info .description {
    margin: 1.5em 0;
  }

  .product-info .button {
    margin-bottom: 0;
  }

  .product-title {
    font-weight: normal;
    margin: 2px 0 14px;
  }

  .product-price {
    font-size: 1.8em;
    font-weight: bolder;
    gap: 0.1em 0.5em;
  }

  .product-price .price.strikethrough {
    flex-basis: 100%;
  }

  .stock-status{
    font-size: 14px;
    color: initial;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5em;
    margin-left: 0.25em;
  }

  .stock-status-color {
    height: 12px;
    width: 12px;
  }

  .stock-status-text {
    margin-top: 2px;
  }

  .deal {
    margin-left: 1em;
  }

  .product-info h3{
    margin-bottom: 0.35em;
  }

  .product-info .detail-items {
    margin: 0.25em 0 0.75em;
  }

  @media screen and (max-width: 620px) {
    .product-box {
      padding: 1em 3em 3em 3em;
    }
    .product-info, .product-image {
      flex: 100%;
    }
    .product-image {
      /* max-height: 350px; */
      margin-bottom: 0.5em;
    }
    .product-container {
      padding: 2em 0;
    }
  }

  @media screen and (max-width: 400px) {
    .product-box {
      padding: 1em 2em 2em 2em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Product.vue